import { WebPlugin } from '@capacitor/core';
export class SecurePreferencesWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.prefix = 'csp:';
    }
    async set(options) {
        const { key, value } = options;
        if (!key)
            throw new Error('key is required');
        localStorage.setItem(this.prefix + key, value);
    }
    async get(options) {
        const { key } = options;
        if (!key)
            throw new Error('key is required');
        const value = localStorage.getItem(this.prefix + key);
        return { value };
    }
    async remove(options) {
        const { key } = options;
        if (!key)
            throw new Error('key is required');
        localStorage.removeItem(this.prefix + key);
    }
    async keys() {
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.startsWith(this.prefix)) {
                keys.push(k.substring(this.prefix.length));
            }
        }
        return { keys };
    }
    async clear() {
        const toRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.startsWith(this.prefix)) {
                toRemove.push(k);
            }
        }
        toRemove.forEach((k) => localStorage.removeItem(k));
    }
}
//# sourceMappingURL=web.js.map